import { createHashRouter } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import Root from "./Root";
import Login from "./pages/auth/Login";
import DashboardFlid from "./pages/dashboard/DashboardFlid";
import FarmersTable from "./pages/farmers/FarmersTable";
import FarmerAdd from "./pages/farmers/FarmerAdd";
import FarmerViewList from "./pages/farmers/farmer-view/FarmerViewList";
import ExpressionTable from "./pages/farmers/expression-of-interest/ExpressionTable";
import ExpressionAdd from "./pages/farmers/expression-of-interest/ExpressionAdd";
import ExpressionViewLIst from "./pages/farmers/expression-of-interest/view/ExpressionViewLIst";
import StandardizedList from "./pages/farmers/expression-of-interest/view/standardization/StandardizedList";
import OverviewList from "./pages/schemes/overview/OverviewList";
import SchemeTable from "./pages/schemes/public/SchemeTable";
import SchemeAdd from "./pages/schemes/public/SchemeAdd";
import ExpressionIspList from "./pages/farmers/expression-of-interest/view/ExpressionIspList";
import SchemeViewList from "./pages/schemes/public/view/SchemeViewList";
import IwuaTable from "./pages/schemes/public/iwua/IwuaTable";
import IwuaViewList from "./pages/schemes/public/iwua/view/IwuaViewList";
import UserViewList from "./pages/user-management/users/user-view/UserViewList";
import UserAdd from "./pages/user-management/users/UserAdd";
import UsersTable from "./pages/user-management/users/UsersTable";
import ProfileTable from "./pages/user-management/profile/ProfileTable";
import ProfileViewList from "./pages/user-management/profile/ProfileViewList";
import IrrigationPartnerTable from "./pages/irrigation-partners/IrrigationPartnerTable";
import PartnerTable from "./pages/irrigation-partners/irrigation-partner-view/PartnerTable";
import PartnerAdd from "./pages/irrigation-partners/irrigation-partner-view/PartnerAdd";
import PartnerList from "./pages/irrigation-partners/irrigation-partner-view/partner-view/PartnerList";
import OngoingProjectsTable from "./pages/projects/ongoing/OngoingProjectsTable";
import ProjectAdd from "./pages/projects/ongoing/ProjectAdd";
import ViewList from "./pages/projects/ongoing/view/ViewList";
import WaterHarvOverview from "./pages/water-harvesting/overview/WaterHarvOverview";
import DamsTable from "./pages/water-harvesting/dams/DamsTable";
import DamAdd from "./pages/water-harvesting/dams/DamAdd";
import EvaluationTable from "./pages/monitoring-and-evaluation/evaluation/EvaluationTable";
import EvaluationAdd from "./pages/monitoring-and-evaluation/evaluation/EvaluationAdd";
import ProjectProgressDetailList from "./pages/monitoring-and-evaluation/progress/progress-view/ProjectProgressDetailList";
import ProgressTable from "./pages/monitoring-and-evaluation/progress/ProgressTable";
import ProgressAdd from "./pages/monitoring-and-evaluation/progress/ProgressAdd";
import EvaluationDetailList from "./pages/monitoring-and-evaluation/evaluation/evaluation-view/EvaluationDetailList";
import PlannedProjectAdd from "./pages/projects/planned/PlannedProjectAdd";
import PlannedProjectsTable from "./pages/projects/planned/PlannedProjectsTable";
import PlannedViewList from "./pages/projects/planned/view/PlannedViewList";
import ProduceMarket from "./pages/schemes/public/crops-produce/ProduceMarket";
import CropProduceList from "./pages/schemes/public/crops-produce/CropProduceList";
import StateAgencyAdd from "./pages/state-agency/StateAgencyAdd";
import StateAgencyTable from "./pages/state-agency/StateAgencyTable";
import CountyGovtTable from "./pages/county-government/CountyGovtTable";
import IwuaAllTable from "./pages/schemes/public/iwua/all/IwuaAllTable";
import LoginOtp from "./pages/auth/LoginOtp";
import AccountLogin from "./pages/auth/AccountLogin";
import FarmerPayList from "./pages/farmers/expression-of-interest/view/farmer-pay-history/FarmerPayList";
import PathwayTable from "./pages/setup/pathway/PathwayTable";
import ProgrammeTable from "./pages/setup/programme/ProgrammeTable";
import ProjectTypeTable from "./pages/setup/project-type/ProjectTypeTable";
import ThresholdTable from "./pages/setup/threshold/ThresholdTable";
import CurrencyTable from "./pages/setup/currency/CurrencyTable";
import DonorTypeTable from "./pages/setup/donor-type/DonorTypeTable";
import Evapotranspiration from "./pages/water-informatics/Evapotranspiration";
import Precipitation from "./pages/water-informatics/Precipitation";
import Biomas from "./pages/water-informatics/Biomas";
import WaterProductivity from "./pages/water-informatics/WaterProductivity";
import WaterFootPrint from "./pages/water-informatics/WaterFootPrint";
import CommunitySchemeTable from "./pages/schemes/community/CommunitySchemeTable";
import CommunityAdd from "./pages/schemes/community/CommunityAdd";
import CommunitySchemeViewList from "./pages/schemes/community/view/CommunitySchemeViewList";
import CommIwuaViewList from "./pages/schemes/community/iwua/view/CommIwuaViewList";
import CommIwuaTable from "./pages/schemes/community/iwua/CommIwuaTable";
import PrivateSchemeTable from "./pages/schemes/private/PrivateSchemeTable";
import PrivateAdd from "./pages/schemes/private/PrivateAdd";
import PrivateSchemeViewList from "./pages/schemes/private/view/PrivateSchemeViewList";
import PrivateIwuaTable from "./pages/schemes/private/iwua/PrivateIwuaTable";
import PrivateIwuaViewList from "./pages/schemes/private/iwua/view/PrivateIwuaViewList";
import CropProducePrivateList from "./pages/schemes/private/crops-produce/CropProducePrivateList";
import CropProduceCommList from "./pages/schemes/community/crops-produce/CropProduceCommList";
import CropProduceAsalList from "./pages/schemes/asal/crops-produce/CropProduceAsalList";
import AsalIwuaViewList from "./pages/schemes/asal/iwua/view/AsalIwuaViewList";
import AsalIwuaTable from "./pages/schemes/asal/iwua/AsalIwuaTable";
import AsalSchemeViewList from "./pages/schemes/asal/view/AsalSchemeViewList";
import AsalAdd from "./pages/schemes/asal/AsalAdd";
import AsalSchemeTable from "./pages/schemes/asal/AsalSchemeTable";
import GrassBandTable from "./pages/land-reclamation/grass-bands/GrassBandTable";
import GrassBandAdd from "./pages/land-reclamation/grass-bands/GrassBandAdd";
import CropBandTable from "./pages/land-reclamation/crop-band/CropBandTable";
import CropBandAdd from "./pages/land-reclamation/crop-band/CropBandAdd";
import TreeCatchmentTable from "./pages/land-reclamation/tree-catchment/TreeCatchmentTable";
import TreeCatchmentAdd from "./pages/land-reclamation/tree-catchment/TreeCatchmentAdd";
import NegarimsTable from "./pages/land-reclamation/negarims/NegarimsTable";
import NegarimsAdd from "./pages/land-reclamation/negarims/NegarimsAdd";
import ReclaimedSchemeAdd from "./pages/land-reclamation/schemes/ReclaimedSchemeAdd";
import ReclaimedSchemeTable from "./pages/land-reclamation/schemes/ReclaimedSchemeTable";
import VirtualWater from "./pages/water-informatics/VirtualWater";
import LandUseClassification from "./pages/water-informatics/LandUseClassification";
import PaymentTypeTable from "./pages/setup/payment-type/PaymentTypeTable";
import VerifiedList from "./pages/farmers/verified/VerifiedList";
import IspPayList from "./pages/farmers/verified/isp-pay-history/IspPayList";
import Hydronomic from "./pages/water-informatics/Hydronomic";
import Drought from "./pages/water-informatics/Drought";
import Climate from "./pages/water-informatics/Climate";
import AgencyTable from "./pages/setup/agency/AgencyTable";
import SubsidySourceTable from "./pages/setup/subsidy-source/SubsidySourceTable";
import DamTypeTable from "./pages/setup/dam-type/DamTypeTable";
import TreatmentTypeTable from "./pages/setup/treatment-type/TreatmentTypeTable";
import AuxiliaryTable from "./pages/setup/auxiliary/AuxiliaryTable";
import WaterPansTable from "./pages/water-harvesting/water-pans/WaterPansTable";
import WaterPanAdd from "./pages/water-harvesting/water-pans/WaterPanAdd";
import WaterSourceTable from "./pages/setup/water-sources/WaterSourceTable";
import WaterApplicationTable from "./pages/setup/water-application/WaterApplicationTable";
import CropTable from "./pages/setup/crop/CropTable";
import Overview from "./pages/water-informatics/Overview";
import BoreholeTable from "./pages/water-harvesting/boreholes/BoreholeTable";
import BoreholeAdd from "./pages/water-harvesting/boreholes/BoreholeAdd";
import PowerSourceTable from "./pages/setup/power-sources/PowerSourceTable";
import WaterUseTable from "./pages/setup/water-use/WaterUseTable";
import WaterSupplyTable from "./pages/water-harvesting/water-supply/WaterSupplyTable";
import WaterSupplyAdd from "./pages/water-harvesting/water-supply/WaterSupplyAdd";
import FloodControlTable from "./pages/water-harvesting/flood-control/FloodControlTable";
import PipelineTypeTable from "./pages/setup/pipeline-type/PipelineTypeTable";
import RiverTrainingAdd from "./pages/water-harvesting/river-training/RiverTrainingAdd";
import RiverTrainingTable from "./pages/water-harvesting/river-training/RiverTrainingTable";
import CheckDamTable from "./pages/water-harvesting/check-dam/CheckDamTable";
import CheckDamAdd from "./pages/water-harvesting/check-dam/CheckDamAdd";
import DykeTypeTable from "./pages/setup/dyke-type/DykeTypeTable";
import FloodControlAdd from "./pages/water-harvesting/flood-control/FloodControlAdd";
import TechnologyTable from "./pages/setup/technology/TechnologyTable";
import ConveyanceTable from "./pages/setup/conveyance/ConveyanceTable";
import FundingModeTable from "./pages/setup/funding-mode/FundingModeTable";
import ReserveTypeTable from "./pages/setup/reserve-type/ReserveTypeTable";
import WtrHarvestingTable from "./pages/setup/water-harvesting/WtrHarvestingTable";
import CompleteProjectsTable from "./pages/projects/complete/CompleteProjectsTable";
import DashboardMain from "./pages/dashboard-main/DashboardMain";
import MainReports from "./pages/reports/MainReports";
import NonSpatialViewList from "./pages/schemes/public/non-spatial-data/NonSpatialViewList";
import IrrigationTypeTable from "./pages/setup/irrigation-type/IrrigationTypeTable";
import LandOwnershipTable from "./pages/setup/land-owership/LandOwnershipTable";
import BankTable from "./pages/setup/banks/BankTable";
import Ecitizen from "./pages/ecitizen/Ecitizen";
import ReclamationOverview from "./pages/land-reclamation/overview/ReclamationOverview";
import PathwaysViewList from "./pages/pathways/view/PathwaysViewList";
import PathwayOverviewList from "./pages/pathways/overview/PathwayOverviewList";
import Landing from "./pages/landing/Landing";
import IndicatorsList from "./pages/schemes/public/kpi/IndicatorsList";
import ServicePerfAddForm from "./pages/schemes/public/kpi/service-perfomance/ServicePerfAddForm";
import ServicePerfView from "./pages/schemes/public/kpi/service-perfomance/ServicePerfView";
import OtherData from "./pages/water-informatics/OtherData";
import ProjectOverviewList from "./pages/projects/overview/ProjectOverviewList";
import StalledProjectsTable from "./pages/projects/stalled/StalledProjectsTable";
import KpiTable from "./pages/setup/kpi/KpiTable";
import KpiDetailsTable from "./pages/setup/kpi-details/KpiDetailsTable";
import CommNonSpatialViewList from "./pages/schemes/community/non-spatial-data/CommNonSpatialViewList";
import CommIndicatorsList from "./pages/schemes/community/kpi/CommIndicatorsList";
import PriNonSpatialViewList from "./pages/schemes/private/non-spatial-data/PriNonSpatialViewList";
import PriIndicatorsList from "./pages/schemes/private/kpi/PriIndicatorsList";
import AsalIndicatorsList from "./pages/schemes/asal/kpi/AsalIndicatorsList";
import AsalNonSpatialViewList from "./pages/schemes/asal/non-spatial-data/AsalNonSpatialViewList";
import WtrAbstractionTable from "./pages/setup/water-abstraction/WtrAbstractionTable";
import EmailForm from "./pages/auth/forgot-password/EmailForm";
import ForgotOtp from "./pages/auth/forgot-password/ForgotOtp";
import ForgotPassword from "./pages/auth/forgot-password/ForgotPassword";
import SoilTypeTable from "./pages/setup/soil-type/SoilTypeTable";
import TypographyTable from "./pages/setup/typography/TypographyTable";
import PressureSystemTable from "./pages/setup/pressure-system/PressureSystemTable";
import FloodControlCategoryTable from "./pages/setup/flood-control/FloodControlCategoryTable";
import MonthlyDetailList from "./pages/monitoring-and-evaluation/monthly-report/monthly-view/MonthlyDetailList";
import MonthlyAdd from "./pages/monitoring-and-evaluation/monthly-report/MonthlyAdd";
import MonthlyTable from "./pages/monitoring-and-evaluation/monthly-report/MonthlyTable";
import ByLaws from "./pages/iwua-portal/documents/by-laws/ByLaws";
import LicenseTable from "./pages/iwua-portal/documents/licenses/LicenseTable";
import Calendar from "./pages/iwua-portal/training/calendar/Calendar";
import Materials from "./pages/iwua-portal/training/material/Materials";
import IwuaOverview from "./pages/iwua-portal/overview/IwuaOverview";
import PanCategoryTable from "./pages/setup/pan-category/PanCategoryTable";
import SchemeKpiTable from "./pages/setup/scheme-kpi/SchemeKpiTable";
import PerformanceTable from "./pages/setup/performance/PerformanceTable";
import AssociatedProjectsTable from "./pages/schemes/public/associated-projects/AssociatedProjectsTable";
import PriAssociatedProjectsTable from "./pages/schemes/private/associated-projects/PriAssociatedProjectsTable";
import CommAssociatedProjectsTable from "./pages/schemes/community/associated-projects/CommAssociatedProjectsTable";
import AsalAssociatedProjectsTable from "./pages/schemes/asal/associated-projects/AsalAssociatedProjectsTable";
import LogsList from "./pages/logs/LogsList";

export const router = createHashRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        path: "/",
        element: <Landing />,
      },

      // {
      // 	path: '/',
      // 	element: <Login />,
      // },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/login-otp",
        element: <LoginOtp />,
      },
      {
        path: "/login-accounts",
        element: <AccountLogin />,
      },
      {
        path: "/forgot-email",
        element: <EmailForm />,
      },
      {
        path: "/verify-forgot-email",
        element: <ForgotOtp />,
      },

      {
        path: "/new-password",
        element: <ForgotPassword />,
      },

      {
        element: <ProtectedRoute role={"EXECUTIVE"} />,
        children: [
          {
            path: "/dashboard-main",
            element: <DashboardMain />,
          },

          {
            path: "/overview-flid",
            element: <DashboardFlid />,
          },

          {
            path: "/farmers-list",
            element: <FarmersTable />,
          },
          {
            path: "/farmers-add",
            element: <FarmerAdd />,
          },
          {
            path: "/farmer-view",
            element: <FarmerViewList />,
          },
          {
            path: "/expression-of-interest",
            element: <ExpressionTable />,
          },
          {
            path: "/farmer/expression-of-interest",
            element: <ExpressionTable />,
          },

          {
            path: "/expression-add",
            element: <ExpressionAdd />,
          },

          {
            path: "/expression-view",
            element: <ExpressionViewLIst />,
          },
          {
            path: "/expression-isp-list",
            element: <ExpressionIspList />,
          },
          {
            path: "/standanrdized-list",
            element: <StandardizedList />,
          },

          {
            path: "/dash-scheme-overview",
            element: <OverviewList />,
          },
          {
            path: "/scheme/public-scheme",
            element: <SchemeTable />,
          },
          {
            path: "/scheme/public-scheme-add",
            element: <SchemeAdd />,
          },
          {
            path: "/scheme/public-scheme-view",
            element: <SchemeViewList />,
          },
          {
            path: "/scheme/iwua-list",
            element: <IwuaTable />,
          },
          {
            path: "/scheme/iwua-view-list",
            element: <IwuaViewList />,
          },
          {
            path: "/scheme/non-spatial-list",
            element: <NonSpatialViewList />,
          },
          {
            path: "/rob/scheme/indicators-list",
            element: <IndicatorsList />,
          },
          {
            path: "/rob/scheme/servicePerf-add-form",
            element: <ServicePerfAddForm />,
          },
          {
            path: "/rob/serviceperf-view",
            element: <ServicePerfView />,
          },
          {
            path: "/rob/scheme/associated-project-list",
            element: <AssociatedProjectsTable />,
          },

          {
            path: "/scheme/community-scheme",
            element: <CommunitySchemeTable />,
          },
          {
            path: "/scheme/community-scheme-add",
            element: <CommunityAdd />,
          },
          {
            path: "/scheme/community-scheme-view",
            element: <CommunitySchemeViewList />,
          },
          {
            path: "/scheme/community/iwua-list",
            element: <CommIwuaTable />,
          },
          {
            path: "/scheme/community/iwua-view-list",
            element: <CommIwuaViewList />,
          },
          {
            path: "/scheme/community/crop-produce",
            element: <CropProduceCommList />,
          },
          {
            path: "/scheme/community/non-spatial-list",
            element: <CommNonSpatialViewList />,
          },
          {
            path: "/rob/scheme/community/indicators-list",
            element: <CommIndicatorsList />,
          },
          {
            path: "/rob/scheme/community/associated-project-list",
            element: <CommAssociatedProjectsTable />,
          },

          {
            path: "/scheme/private-scheme",
            element: <PrivateSchemeTable />,
          },
          {
            path: "/scheme/private-scheme-add",
            element: <PrivateAdd />,
          },
          {
            path: "/scheme/private-scheme-view",
            element: <PrivateSchemeViewList />,
          },
          {
            path: "/scheme/private/iwua-list",
            element: <PrivateIwuaTable />,
          },
          {
            path: "/scheme/private/iwua-view-list",
            element: <PrivateIwuaViewList />,
          },
          {
            path: "/scheme/private/crop-produce",
            element: <CropProducePrivateList />,
          },
          {
            path: "/scheme/private/non-spatial-list",
            element: <PriNonSpatialViewList />,
          },
          {
            path: "/rob/scheme/private/indicators-list",
            element: <PriIndicatorsList />,
          },
          {
            path: "/rob/scheme/private/associated-project-list",
            element: <PriAssociatedProjectsTable />,
          },

          {
            path: "/scheme/asal-scheme",
            element: <AsalSchemeTable />,
          },
          {
            path: "/scheme/asal-scheme-add",
            element: <AsalAdd />,
          },
          {
            path: "/scheme/asal-scheme-view",
            element: <AsalSchemeViewList />,
          },
          {
            path: "/scheme/asal/iwua-list",
            element: <AsalIwuaTable />,
          },
          {
            path: "/scheme/asal/iwua-view-list",
            element: <AsalIwuaViewList />,
          },
          {
            path: "/scheme/asal/crop-produce",
            element: <CropProduceAsalList />,
          },
          {
            path: "/scheme/asal/non-spatial-list",
            element: <AsalNonSpatialViewList />,
          },
          {
            path: "/rob/scheme/asal/indicators-list",
            element: <AsalIndicatorsList />,
          },
          {
            path: "/rob/scheme/asal/associated-project-list",
            element: <AsalAssociatedProjectsTable />,
          },

          {
            path: "/user/users-list",
            element: <UsersTable />,
          },
          {
            path: "user/user-add",
            element: <UserAdd />,
          },
          {
            path: "user/user-view",
            element: <UserViewList />,
          },
          {
            path: "user/profile-list",
            element: <ProfileTable />,
          },
          {
            path: "user/profile-view-list",
            element: <ProfileViewList />,
          },
          {
            path: "logs",
            element: <LogsList />,
          },

          {
            path: "/irrigation-partner-list",
            element: <IrrigationPartnerTable />,
          },
          {
            path: "/irrigation-partner-view",
            element: <PartnerTable />,
          },
          {
            path: "/irrigation-partner-add",
            element: <PartnerAdd />,
          },
          {
            path: "/partner-view",
            element: <PartnerList />,
          },
          {
            path: "/project-overview",
            element: <ProjectOverviewList />,
          },
          {
            path: "/ongoing-projects",
            element: <OngoingProjectsTable />,
          },
          {
            path: "/project-add",
            element: <ProjectAdd />,
          },
          {
            path: "/project-view",
            element: <ViewList />,
          },
          {
            path: "/completed-projects",
            element: <CompleteProjectsTable />,
          },
          {
            path: "/stalled-projects",
            element: <StalledProjectsTable />,
          },

          {
            path: "/rob/water-harvesting-overview",
            element: <WaterHarvOverview />,
          },
          {
            path: "/rob/dams-list",
            element: <DamsTable />,
          },
          {
            path: "/rob/dams-add",
            element: <DamAdd />,
          },
          {
            path: "/rob/water-pans",
            element: <WaterPansTable />,
          },
          {
            path: "/rob/pan-add",
            element: <WaterPanAdd />,
          },
          {
            path: "/rob/boreholes",
            element: <BoreholeTable />,
          },
          {
            path: "/rob/borehole-add",
            element: <BoreholeAdd />,
          },
          {
            path: "/rob/water-supply",
            element: <WaterSupplyTable />,
          },
          {
            path: "/rob/water-supply-add",
            element: <WaterSupplyAdd />,
          },
          {
            path: "/rob/flood-control",
            element: <FloodControlTable />,
          },
          {
            path: "/rob/flood-control-add",
            element: <FloodControlAdd />,
          },
          {
            path: "/rob/river-training",
            element: <RiverTrainingTable />,
          },
          {
            path: "/rob/river-training-add",
            element: <RiverTrainingAdd />,
          },

          {
            path: "/rob/check-dam",
            element: <CheckDamTable />,
          },
          {
            path: "/rob/check-dam-add",
            element: <CheckDamAdd />,
          },

          {
            path: "/rob/project-progress",
            element: <ProgressTable />,
          },
          {
            path: "/rob/progress-add",
            element: <ProgressAdd />,
          },
          {
            path: "/rob/progress-details",
            element: <ProjectProgressDetailList />,
          },
          {
            path: "/rob/project-evaluations",
            element: <EvaluationTable />,
          },
          {
            path: "/rob/evaluation-add",
            element: <EvaluationAdd />,
          },
          {
            path: "/rob/evaluation-details",
            element: <EvaluationDetailList />,
          },

          {
            path: "/rob/monthly-report",
            element: <MonthlyTable />,
          },
          {
            path: "/rob/monthly-add",
            element: <MonthlyAdd />,
          },
          {
            path: "/rob/monthly-details",
            element: <MonthlyDetailList />,
          },

          {
            path: "/planned-project-add",
            element: <PlannedProjectAdd />,
          },
          {
            path: "/planned-pipeline",
            element: <PlannedProjectsTable />,
          },
          {
            path: "/planned-pipeline-details",
            element: <PlannedViewList />,
          },
          {
            path: "/scheme/crop-produce",
            element: <CropProduceList />,
          },
          {
            path: "/state-agency",
            element: <StateAgencyTable />,
          },
          {
            path: "/state-agency-add",
            element: <StateAgencyAdd />,
          },

          {
            path: "/evapotranspiration",
            element: <Evapotranspiration />,
          },
          {
            path: "/precipitation",
            element: <Precipitation />,
          },
          {
            path: "/biomass-production",
            element: <Biomas />,
          },
          {
            path: "/water-productivity",
            element: <WaterProductivity />,
          },
          {
            path: "/water-footprint",
            element: <WaterFootPrint />,
          },
          {
            path: "/virtual-water",
            element: <VirtualWater />,
          },
          {
            path: "/land-cover-classification",
            element: <LandUseClassification />,
          },
          {
            path: "/hydronomic-zoning",
            element: <Hydronomic />,
          },
          {
            path: "/drought-condition",
            element: <Drought />,
          },
          {
            path: "/climate-change",
            element: <Climate />,
          },
          {
            path: "/other-data",
            element: <OtherData />,
          },

          {
            path: "/water-informatics-overview",
            element: <Overview />,
          },

          {
            path: "/county-government",
            element: <CountyGovtTable />,
          },
          {
            path: "/scheme/iwuas",
            element: <IwuaAllTable />,
          },
          {
            path: "/farmer-paylist",
            element: <FarmerPayList />,
          },

          // Setups
          {
            path: "/rob/pathway",
            element: <PathwayTable />,
          },
          {
            path: "/rob/programme",
            element: <ProgrammeTable />,
          },
          {
            path: "/rob/project-type",
            element: <ProjectTypeTable />,
          },
          {
            path: "/rob/threshold",
            element: <ThresholdTable />,
          },
          {
            path: "/rob/currency",
            element: <CurrencyTable />,
          },
          {
            path: "/rob/donor-type",
            element: <DonorTypeTable />,
          },
          {
            path: "/rob/payment-type",
            element: <PaymentTypeTable />,
          },
          {
            path: "/rob/agency-setup",
            element: <AgencyTable />,
          },
          {
            path: "/rob/subsidy-source",
            element: <SubsidySourceTable />,
          },
          {
            path: "/rob/dam-type",
            element: <DamTypeTable />,
          },
          {
            path: "/rob/treatment-type",
            element: <TreatmentTypeTable />,
          },
          {
            path: "/rob/auxiliary-type",
            element: <AuxiliaryTable />,
          },
          {
            path: "/rob/water-sources",
            element: <WaterSourceTable />,
          },
          {
            path: "/rob/water-application",
            element: <WaterApplicationTable />,
          },
          {
            path: "/rob/major-crops",
            element: <CropTable />,
          },
          {
            path: "/rob/power-source",
            element: <PowerSourceTable />,
          },
          {
            path: "/rob/water-use",
            element: <WaterUseTable />,
          },
          {
            path: "/rob/pipeline-type",
            element: <PipelineTypeTable />,
          },
          {
            path: "/rob/dyke-type",
            element: <DykeTypeTable />,
          },
          {
            path: "/rob/reclamation-technology",
            element: <TechnologyTable />,
          },
          {
            path: "/rob/conveyance",
            element: <ConveyanceTable />,
          },
          {
            path: "/rob/funding-mode",
            element: <FundingModeTable />,
          },
          {
            path: "/rob/reserve-type",
            element: <ReserveTypeTable />,
          },
          {
            path: "/rob/water-harvesting",
            element: <WtrHarvestingTable />,
          },
          {
            path: "/rob/irrigation-type",
            element: <IrrigationTypeTable />,
          },
          {
            path: "/rob/land-ownership",
            element: <LandOwnershipTable />,
          },
          {
            path: "/rob/bank",
            element: <BankTable />,
          },
          {
            path: "/rob/kpi",
            element: <KpiTable />,
          },
          {
            path: "/rob/kpi-details",
            element: <KpiDetailsTable />,
          },
          {
            path: "/rob/wtr-abstraction",
            element: <WtrAbstractionTable />,
          },
          {
            path: "/rob/soil-type",
            element: <SoilTypeTable />,
          },
          {
            path: "/rob/typography",
            element: <TypographyTable />,
          },
          {
            path: "/rob/pressure-system",
            element: <PressureSystemTable />,
          },
          {
            path: "/rob/flood-control-category",
            element: <FloodControlCategoryTable />,
          },
          {
            path: "/rob/pan-category",
            element: <PanCategoryTable />,
          },
          {
            path: "/rob/scheme-kpi-setup",
            element: <SchemeKpiTable />,
          },
          {
            path: "/rob/performance",
            element: <PerformanceTable />,
          },

          {
            path: "/rob/reclamation-overview",
            element: <ReclamationOverview />,
          },
          {
            path: "/rob/semicircular-bands-for-grass",
            element: <GrassBandTable />,
          },
          {
            path: "/rob/grass-band-add",
            element: <GrassBandAdd />,
          },
          {
            path: "/rob/trapezoidal-bund-for-crops",
            element: <CropBandTable />,
          },
          {
            path: "/rob/crop-band-add",
            element: <CropBandAdd />,
          },
          {
            path: "/rob/triangular-micro-catchment-for-trees",
            element: <TreeCatchmentTable />,
          },
          {
            path: "/rob/tree-add",
            element: <TreeCatchmentAdd />,
          },
          {
            path: "/rob/negarims",
            element: <NegarimsTable />,
          },
          {
            path: "/rob/negarim-add",
            element: <NegarimsAdd />,
          },
          {
            path: "/rob/reclaimed-scheme",
            element: <ReclaimedSchemeTable />,
          },
          {
            path: "/rob/rob/reclaimed-scheme-add",
            element: <ReclaimedSchemeAdd />,
          },
          {
            path: "/verified-expression-list",
            element: <VerifiedList />,
          },
          {
            path: "/isp-pay-list",
            element: <IspPayList />,
          },
          {
            path: "/reports",
            element: <MainReports />,
          },
          {
            path: "/e-citizen-data",
            element: <Ecitizen />,
          },
          {
            path: "/rob/pathway-overview",
            element: <PathwayOverviewList />,
          },
          {
            path: "/rob/pathway-view",
            element: <PathwaysViewList />,
          },

          // Iwua Portal start
          {
            path: "/rob/by-laws",
            element: <ByLaws />,
          },
          {
            path: "/rob/licenses",
            element: <LicenseTable />,
          },
          {
            path: "/rob/calendar",
            element: <Calendar />,
          },
          {
            path: "/rob/materials",
            element: <Materials />,
          },
          {
            path: "/rob/iwua-overview",
            element: <IwuaOverview />,
          },

          // Iwua Portal end
        ],
      },
      {
        path: "*",
        element: <p>404 - Error: Page not found</p>,
      },
    ],
  },
]);
